import { ReactNode, forwardRef } from "react";
import { Box, BoxProps } from "@chakra-ui/react";

const Wrapper = forwardRef<HTMLDivElement, BoxProps & { children: ReactNode }>(
  ({ children, px = { base: "16px", md: "40px" }, w = "100%", ...rest }, ref) => (
    <Box ref={ref} px={px} w={w} {...rest} className="wrapper">
      {children}
    </Box>
  )
);

export default Wrapper;